import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { css } from '@emotion/react';

import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import Button from 'components/field/Button';
import Image from 'components/global/Image';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';
import { updateDynamicListsInPage } from 'components/list/dynamicListSlice';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import AppLogger from 'utils/AppLogger';

import { faCheck } from '@fortawesome/pro-solid-svg-icons';

import * as S from './FullDayWorkingHoursModal.styled';

const FullDayWorkingHoursModal = NiceModal.create((props) => {
	const { ids, endpointUrl, type = 'warehouse' } = props;
	const modal = useModal();
	const axiosPrivate = useAxiosPrivate();
	const { showError, showSuccess } = useAlert();
	const handleCloseModal = () => modal.remove();
	const dispatch = useDispatch();

	const formMethods = useForm({
		defaultValues: {
			IDs: ids
		}
	});

	const {
		handleSubmit,
		formState: { isSubmitting, isLoading: isFormLoading }
	} = formMethods;
	const isLoading = isSubmitting || isFormLoading;

	const onSubmit = async (data) => {
		try {
			const response = await axiosPrivate.post(endpointUrl, data);

			if (response?.status === 200) {
				showSuccess();
				dispatch(updateDynamicListsInPage());
				handleCloseModal();
			} else {
				AppLogger.error(response);
			}
		} catch (error) {
			AppLogger.error(error);
			showError({
				message: error?.response?.data?.code || error?.response?.data?.message
			});
		}
	};

	return (
		<Modal maxWidth="small" fullwidth className="fullday-working-hours-modal" closeButton={true}>
			<ModalTitle>
				<Typography variant="p1">fullDayWorkingHoursModal.title</Typography>
			</ModalTitle>
			<ModalContent>
				<S.Container>
					<S.ImageContainer>
						<Image
							url={
								'https://storage.googleapis.com/tryoto-public/public/assets/icons/working-hours-clock.svg'
							}
							width="7rem"
							height="7rem"
						/>
					</S.ImageContainer>
					<S.TextWrapper>
						<Typography noWrap variant="p2" fontWeight="500">
							{`fullDayWorkingHoursModal.${type}.header`}
						</Typography>
						<Typography noWrap color="var(--content-3)" variant="p3">
							{`fullDayWorkingHoursModal.${type}.description`}
						</Typography>
					</S.TextWrapper>
				</S.Container>
			</ModalContent>
			<ModalActions>
				<Button
					label="cancel"
					css={css`
						text-decoration: underline;
						border: none !important;
					`}
					variant="borderless"
					onClick={handleCloseModal}
				/>
				<Button
					size="large"
					icon={faCheck}
					loading={isLoading}
					onClick={handleSubmit(onSubmit, (errors) => {
						AppLogger.log(errors);
					})}
					label="confirm"
				/>
			</ModalActions>
		</Modal>
	);
});

export default FullDayWorkingHoursModal;
